import { SET_USER_INFO, SET_LEARNING_STATISTICS } from './types';

export default {
  setUserInfo({ commit }: any, user: any) {
    commit(SET_USER_INFO, user);
  },
  setLearningStatistics({ commit }: any, statistics: any) {
    commit(SET_LEARNING_STATISTICS, statistics);
  },
};
